import { Button, Text, Flex, Box } from '@chakra-ui/react';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import React, { ReactElement } from 'react';
import { Breakpoints } from 'types/breakpoints';
import { ModalWorksheetDeleteBlockVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModal } from '../../CustomModal';
import { CustomModalContent } from '../../CustomModalContent';

type Props = SharedModalProps & ModalWorksheetDeleteBlockVariantProps;

export const WorksheetDeleteBlockModal = ({
  handleClose,
  isShown,
  name,
  onAccept,
  onCancel,
}: Props): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);
  const handleAccept = async (): Promise<void> => {
    if (onAccept) await onAccept();
    handleClose();
  };
  const handleCancel = async (): Promise<void> => {
    if (onCancel) await onCancel();
    handleClose();
  };

  return (
    <CustomModal
      isOpen={isShown}
      onClose={handleClose}
      placement="center"
      size="md"
      hideHeader={!isDesktop}
    >
      <CustomModalContent
        p={{ base: '0', md: '0 40px 30px' }}
        display="flex"
        flexDirection="column"
      >
        <Box
          p={{ base: 'l', md: '0' }}
          textAlign={{ base: 'center', md: 'left' }}
          mb={{ md: '30px' }}
        >
          <Text>
            Möchtest du den Block &quot;{name}&quot; wirklich löschen? <br />
            Diese Aktion kann über Strg+Z (Windows) bzw. Cmd+Z (Mac) rückgängig gemacht werden.
          </Text>
        </Box>
        <Flex
          justifyContent="flex-end"
          w="full"
          h={{ base: '60px', md: 'fit-content' }}
          borderTop={{ base: 'default', md: 'none' }}
          borderColor="border.accent"
          p="0"
        >
          <Button onClick={handleCancel} variant="tertiary">
            Abbrechen
          </Button>
          <Button variant="destructive" onClick={handleAccept}>
            Löschen
          </Button>
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
